<script type="text/javascript">
	import { identity } from "../Branding/Store";

	const changeFavicon = (link) => {
		let favicon = document.querySelector('link[rel="icon"]');
		if (favicon !== null) {
			favicon.href = link;
		} 
		else {
			favicon = document.createElement("link");
			favicon.rel = "icon";
			favicon.href = link;
			document.head.appendChild(favicon);
		}
	}
	// changeFavicon($identity.favicon);

</script>
